import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AdShelfCard = ({ shelf }) => {
    const navigate = useNavigate();
    const { name } = useParams();

    // Guard against undefined shelf/products
    const products = useMemo(() => shelf?.products || [], [shelf]);

    const [focusedProduct, setFocusedProduct] = useState(
        products.length > 0 ? products[0] : null
    );

    if (!shelf) return null;

    return (
        <div className="ad">
            <div className="shelf-ad-body">
                <div className="shelf-ad-text">
                    <h3>{shelf.name}</h3>
                    <p>{shelf.description}</p>
                </div>

                <div className="shelf-ad-images">
                    {focusedProduct?.files?.[0]?.url && (
                        <img
                            src={focusedProduct.files[0].url}
                            alt={focusedProduct.title || "Product"}
                        />
                    )}

                    <p>{focusedProduct?.title}</p>

                    <div className="shelf-ad-images-select">
                        {products.map((product) => (
                            <img
                                key={product._id}
                                src={product?.files?.[0]?.url}
                                alt={product?.title || "Product"}
                                onClick={() => setFocusedProduct(product)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <button
                className="promote-btn"
                onClick={() =>
                    navigate(`/b/manage/${name}/promotions/shelf/create`, {
                        state: { ad: shelf, adType: "shelf" },
                    })
                }
            >
                Promote
            </button>
        </div>
    );
};

export default AdShelfCard;